/* ============================================================
   SAFF DOĞAL TAŞ — DOĞUM HARİTASI · ana motor (Osmanlı motorundan uyarlandı, 23 Eyl 2026)
   Bağımlılıklar: saff-astro.js (hesap), saff-harita-icerik.js (yorum), saff-sehirler.js,
                  saff-cark.js (Canvas çark, yedek), saff-3d.js (WebGL gök küresi)
   Ürün verisi Liquid'den #odt-harita-veri ile gelir (canlı fiyat/stok).
   ============================================================ */
(function () {
  'use strict';

  var kok = document.querySelector('.odt-nh');
  if (!kok || !window.ODTAstro || !window.ODTIcerik) return;

  var A = window.ODTAstro, I = window.ODTIcerik, C = window.ODTCark;
  var SEHIR = window.ODTSehir || [];

  /* ---------------------------------------------------------- yardımcı */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(t, c, h) { var n = document.createElement(t); if (c) n.className = c; if (h != null) n.innerHTML = h; return n; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[m];
    });
  }
  function paraFmt(kurus, bicim) {
    var t = kurus / 100;
    return t.toLocaleString('tr-TR', { minimumFractionDigits: t % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' ' + (bicim || 'TL');
  }
  /* Türkçe arama: büyük/küçük ve aksan duyarsız */
  function sadelestir(s) {
    return String(s).toLocaleLowerCase('tr')
      .replace(/ı/g,'i').replace(/ğ/g,'g').replace(/ü/g,'u')
      .replace(/ş/g,'s').replace(/ö/g,'o').replace(/ç/g,'c').replace(/â/g,'a');
  }

  var VERI = {};
  try { VERI = JSON.parse(($('#odt-harita-veri') || {}).textContent || '{}'); } catch (e) { VERI = {}; }
  var URUN = VERI.urunler || {}, PARA = VERI.para || 'TL';

  var AYLAR = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];

  var D = { ad:'', soyad:'', gun:0, ay:0, yil:0, saat:12, dakika:0, saatBilinmiyor:false,
            sehir:null, email:'', cevap:{}, i:0, harita:null, testId:'' };

  function yeniId() {
    var abc = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', r = '';
    for (var i = 0; i < 8; i++) r += abc.charAt(Math.floor(Math.random() * abc.length));
    return 'DH-' + r;
  }

  /* ---------------------------------------------------------- ekran */
  var ILK = true, zodyak = null, cark = null, sahne3 = null;
  /* Ekran geçişi:
     · Sayfa KENDİLİĞİNDEN zıplamaz (tarayıcının yaptığı kayma geri alınır).
     · Ama yeni ekranın üstü görünür alanın YUKARISINDA kaldıysa oraya çekilir —
       yoksa uzun formdan sonra kullanıcı boş ekrana bakıp elle yukarı çıkmak zorunda kalıyordu. */
  function ekran(ad) {
    var y = window.pageYOffset;
    $$('.nh-screen', kok).forEach(function (n) { n.classList.toggle('is-on', n.dataset.screen === ad); });
    if (Math.round(window.pageYOffset) !== Math.round(y)) window.scrollTo(0, y);

    if (!ILK) {
      var aktif = $('.nh-screen.is-on', kok);
      if (aktif) {
        var ust = aktif.getBoundingClientRect().top;
        if (ust < 8) {                                   // ekran yukarıda kalmış → görünür yap
          var hedef = Math.max(0, ust + window.pageYOffset - 16);
          try { window.scrollTo({ top: hedef, behavior: 'smooth' }); }
          catch (e) { window.scrollTo(0, hedef); }
        }
      }
    }
    if (ILK) { ILK = false; }
    /* 3B gök alanı yalnız soru/hesap ekranlarında */
    if (ad === 'soru' || ad === 'hesap') Alan.basla(); else Alan.dur();
    if (zodyak) { if (ad === 'gate') zodyak.basla(); else zodyak.dur(); }
    if (cark) { if (ad === 'sonuc') cark.basla(); else cark.dur(); }
    if (sahne3) { if (ad === 'sonuc') sahne3.basla(); else sahne3.dur(); }
    if (hesapZodyak) { if (ad === 'hesap') hesapZodyak.basla(); else hesapZodyak.dur(); }
  }

  /* ---------------------------------------------------------- yıldızlar */
  (function () {
    var w = $('.nh-stars', kok); if (!w) return;
    var n = window.innerWidth < 700 ? 50 : 100, h = '';
    for (var i = 0; i < n; i++) {
      h += '<i style="left:' + (Math.random()*100).toFixed(2) + '%;top:' + (Math.random()*100).toFixed(2) +
           '%;--dur:' + (2.5+Math.random()*4).toFixed(1) + 's;--del:' + (Math.random()*5).toFixed(1) + 's"></i>';
    }
    w.innerHTML = h;
  })();

  /* ---------------------------------------------------------- 3B gök alanı (soru ekranı) */
  var Alan = (function () {
    var cv, cx, en = 0, boy = 0, dpr = 1, calisiyor = false, kare = null, t = 0, parc = [], halka = [];
    var AZ = window.matchMedia('(max-width:820px)').matches;
    var N = AZ ? 110 : 240, F = 640;
    function kur() {
      cv = document.createElement('canvas'); cv.className = 'nh-3d'; cv.setAttribute('aria-hidden','true');
      kok.insertBefore(cv, kok.firstChild.nextSibling);
      cx = cv.getContext('2d'); olcek();
      for (var i = 0; i < N; i++) parc.push(yeni(true));
      [[200,0],[280,0.9],[150,1.9]].forEach(function (h) {
        var nk = [], adet = AZ ? 30 : 48;
        for (var i = 0; i < adet; i++) {
          var a = i/adet*Math.PI*2;
          nk.push({ x: Math.cos(a)*h[0], y: Math.sin(a)*h[0] });
        }
        halka.push({ n: nk, egim: h[1] });
      });
      window.addEventListener('resize', olcek);
    }
    function olcek() {
      dpr = Math.min(2, window.devicePixelRatio || 1);
      var r = kok.getBoundingClientRect();
      en = Math.max(320, r.width); boy = Math.max(420, r.height);
      cv.width = Math.round(en*dpr); cv.height = Math.round(boy*dpr);
      cv.style.width = en+'px'; cv.style.height = boy+'px';
      cx.setTransform(dpr,0,0,dpr,0,0);
    }
    function yeni(ilk) {
      return { x:(Math.random()-.5)*1100, y:(Math.random()-.5)*900,
               z: ilk ? Math.random()*900-200 : 760,
               r:.5+Math.random()*1.6, p:Math.random()*6.283 };
    }
    function yans(x,y,z,yaw,pit) {
      var cs=Math.cos(yaw), sn=Math.sin(yaw);
      var x1=x*cs-z*sn, z1=x*sn+z*cs;
      var cp=Math.cos(pit), sp=Math.sin(pit);
      var y1=y*cp-z1*sp, z2=y*sp+z1*cp;
      var d=F+z2; if(d<40) return null;
      var s=F/d;
      return { x: en/2+x1*s, y: boy/2+y1*s, s:s };
    }
    function ciz() {
      if (!calisiyor) return;
      t++; cx.clearRect(0,0,en,boy);
      var yaw=t*0.0018, pit=Math.sin(t*0.0008)*0.26;
      var g=cx.createRadialGradient(en/2,boy/2,0,en/2,boy/2,Math.min(en,boy)*.55);
      g.addColorStop(0,'rgba(201,169,97,.045)'); g.addColorStop(1,'rgba(0,0,0,0)');
      cx.fillStyle=g; cx.fillRect(0,0,en,boy);
      halka.forEach(function (h,hi) {
        cx.beginPath(); var ilk=true;
        h.n.forEach(function (n) {
          var p=yans(n.x,n.y,0,yaw*(1+hi*.3),pit+h.egim); if(!p){ilk=true;return;}
          if(ilk){cx.moveTo(p.x,p.y);ilk=false;} else cx.lineTo(p.x,p.y);
        });
        cx.closePath();
        cx.strokeStyle='rgba(201,169,97,'+(0.13+hi*0.02).toFixed(3)+')'; cx.lineWidth=1; cx.stroke();
      });
      for (var i=0;i<parc.length;i++) {
        var q=parc[i]; q.z-=1.1;
        if(q.z<-560){parc[i]=yeni(false);continue;}
        var p=yans(q.x,q.y,q.z,yaw*.5,pit*.5); if(!p) continue;
        var al=Math.min(1,p.s*.8)*(0.26+0.28*Math.sin(t*0.028+q.p));
        if(al<=0.01) continue;
        cx.beginPath(); cx.arc(p.x,p.y,Math.max(.4,q.r*p.s),0,6.283);
        cx.fillStyle='rgba(232,206,147,'+al.toFixed(3)+')'; cx.fill();
      }
      kare=requestAnimationFrame(ciz);
    }
    return {
      basla: function () {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!cv) kur();
        if (calisiyor) return;
        calisiyor=true; kok.classList.add('nh-3d-on'); kare=requestAnimationFrame(ciz);
      },
      dur: function () { calisiyor=false; kok.classList.remove('nh-3d-on'); if(kare) cancelAnimationFrame(kare); }
    };
  })();

  /* ---------------------------------------------------------- kapı + hesap zodyağı */
  var hesapZodyak = null;
  (function () {
    if (!C) return;
    var w = $('#nhZodyak', kok);
    if (w) { var cv = document.createElement('canvas'); w.appendChild(cv); zodyak = C.Zodyak(cv); zodyak.basla();
      /* SAFF: WebGL varsa Canvas zodyağın yerine 3B usturlab (saff-3d.js) */
      if (window.Saff3D) window.Saff3D.astrolabe(w, { yogun: true }).then(function (s3) { try { zodyak.dur(); } catch (e) {} cv.style.display = 'none'; zodyak = s3; }).catch(function () {}); }
    var hc = $('#nhHesapCark', kok);
    if (hc) hesapZodyak = C.Zodyak(hc);
  })();

  /* ---------------------------------------------------------- tarih/saat seçicileri */
  (function () {
    var g = $('#nhGun', kok), a = $('#nhAy', kok), y = $('#nhYil', kok),
        s = $('#nhSaat', kok), dk = $('#nhDakika', kok);
    if (!g) return;
    var h = '<option value="">Gün</option>';
    for (var i = 1; i <= 31; i++) h += '<option value="'+i+'">'+i+'</option>'; g.innerHTML = h;
    h = '<option value="">Ay</option>';
    for (var m = 0; m < 12; m++) h += '<option value="'+(m+1)+'">'+AYLAR[m]+'</option>'; a.innerHTML = h;
    var su = new Date().getFullYear();
    h = '<option value="">Yıl</option>';
    for (var yy = su - 13; yy >= su - 95; yy--) h += '<option value="'+yy+'">'+yy+'</option>'; y.innerHTML = h;
    h = '';
    for (var sa = 0; sa < 24; sa++) h += '<option value="'+sa+'">'+(sa<10?'0':'')+sa+'</option>'; s.innerHTML = h;
    h = '';
    for (var d2 = 0; d2 < 60; d2 += 5) h += '<option value="'+d2+'">'+(d2<10?'0':'')+d2+'</option>'; dk.innerHTML = h;
    s.value = '12'; dk.value = '0';
  })();

  /* ---------------------------------------------------------- şehir arama */
  (function () {
    var giris = $('#nhSehir', kok), kutu = $('#nhSehirOneri', kok);
    if (!giris || !kutu) return;
    var secili = -1, sonuc = [];

    function ara(q) {
      var s = sadelestir(q.trim());
      if (!s) return [];
      var tam = [], bas = [], ic = [];
      SEHIR.forEach(function (x) {
        var a = sadelestir(x.ad);
        if (a === s) tam.push(x);
        else if (a.indexOf(s) === 0) bas.push(x);
        else if (a.indexOf(s) > 0) ic.push(x);
      });
      return tam.concat(bas, ic).slice(0, 8);
    }
    function goster(liste) {
      sonuc = liste; secili = -1;
      if (!liste.length) { kutu.hidden = true; kutu.innerHTML = ''; return; }
      kutu.innerHTML = liste.map(function (x, i) {
        return '<button type="button" data-i="'+i+'">'+esc(x.ad) +
               '<small>'+(x.tr ? 'Türkiye' : 'UTC'+(x.tz>=0?'+':'')+x.tz)+'</small></button>';
      }).join('');
      kutu.hidden = false;
      $$('button', kutu).forEach(function (b) {
        b.addEventListener('click', function () { sec(liste[+b.dataset.i]); });
      });
    }
    function sec(x) {
      D.sehir = x; giris.value = x.ad; kutu.hidden = true;
      $('#nhSehirBilgi', kok).textContent = x.lat.toFixed(2)+'° / '+x.lon.toFixed(2)+'° · UTC'+(x.tz>=0?'+':'')+x.tz;
    }
    giris.addEventListener('input', function () { D.sehir = null; $('#nhSehirBilgi',kok).textContent=''; goster(ara(giris.value)); });
    giris.addEventListener('focus', function () { if (giris.value) goster(ara(giris.value)); });
    giris.addEventListener('keydown', function (e) {
      if (kutu.hidden || !sonuc.length) return;
      var bt = $$('button', kutu);
      if (e.key === 'ArrowDown') { e.preventDefault(); secili = Math.min(sonuc.length-1, secili+1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); secili = Math.max(0, secili-1); }
      else if (e.key === 'Enter') { if (secili >= 0) { e.preventDefault(); sec(sonuc[secili]); } return; }
      else if (e.key === 'Escape') { kutu.hidden = true; return; }
      else return;
      bt.forEach(function (b,i) { b.classList.toggle('is-sec', i === secili); });
    });
    document.addEventListener('click', function (e) {
      if (!kutu.contains(e.target) && e.target !== giris) kutu.hidden = true;
    });
  })();

  /* saat bilinmiyor */
  (function () {
    var c = $('#nhSaatYok', kok); if (!c) return;
    c.addEventListener('change', function () {
      var kapali = c.checked;
      $('#nhSaat', kok).disabled = kapali;
      $('#nhDakika', kok).disabled = kapali;
      $('#nhSaatUyari', kok).hidden = !kapali;
    });
  })();

  /* ---------------------------------------------------------- kapı → form */
  var basla = $('#nhBasla', kok);
  if (basla) basla.addEventListener('click', function () {
    ekran('kimlik');
    setTimeout(function () { var i = $('#nhAd', kok); if (i) { try { i.focus({preventScroll:true}); } catch(e){} } }, 400);
  });

  /* ---------------------------------------------------------- form gönder */
  var form = $('#nhKimlik', kok);
  if (form) form.addEventListener('submit', function (ev) {
    ev.preventDefault();
    var hata = $('#nhHata', kok);
    var ad = ($('#nhAd', kok).value||'').trim(), soyad = ($('#nhSoyad', kok).value||'').trim();
    var g = +$('#nhGun',kok).value, a = +$('#nhAy',kok).value, y = +$('#nhYil',kok).value;
    var saatYok = $('#nhSaatYok',kok).checked;
    var sa = saatYok ? 12 : +$('#nhSaat',kok).value;
    var dk = saatYok ? 0 : +$('#nhDakika',kok).value;
    var ep = ($('#nhMail',kok).value||'').trim();

    if (ad.length < 2) { hata.textContent = 'Lütfen adınızı yazın.'; return; }
    if (!g || !a || !y) { hata.textContent = 'Lütfen doğum tarihinizi eksiksiz seçin.'; return; }
    var d = new Date(y, a-1, g);
    if (d.getFullYear()!==y || d.getMonth()!==a-1 || d.getDate()!==g) { hata.textContent='Bu tarih geçerli değil.'; return; }
    if (!D.sehir) { hata.textContent = 'Lütfen listeden bir doğum yeri seçin.'; return; }
    if (ep && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(ep)) { hata.textContent='E-posta adresi geçerli görünmüyor.'; return; }
    hata.textContent = '';

    D.ad=ad; D.soyad=soyad; D.gun=g; D.ay=a; D.yil=y; D.saat=sa; D.dakika=dk;
    D.saatBilinmiyor=saatYok; D.email=ep; D.cevap={}; D.i=0; D.testId=yeniId();

    var hg = $('#nhHosgeldin', kok);
    if (hg) {
      hg.innerHTML = '<div class="nh-eyebrow">Merhaba ' + esc(ad) + '</div>' +
        '<p class="nh-lede" style="max-width:640px;margin:0 auto">' +
        esc(g + ' ' + AYLAR[a-1] + ' ' + y) + (saatYok ? '' : ', ' + (sa<10?'0':'')+sa+':'+(dk<10?'0':'')+dk) +
        ' · ' + esc(D.sehir.ad) + '.<br>Gökyüzü o an nasıl duruyordu, birazdan göreceksin. ' +
        'Önce beş kısa soru — bunlar haritanı değiştirmez, yorumun sana en çok gereken yerden başlamasını sağlar.</p>';
    }
    ekran('gecis');
  });

  var gecisBtn = $('#nhGecis', kok);
  if (gecisBtn) gecisBtn.addEventListener('click', function () { ekran('soru'); soruCiz(); });

  /* ---------------------------------------------------------- sorular */
  function soruCiz() {
    var q = I.SORULAR[D.i];
    $('#nhPnum', kok).textContent = (D.i+1) + ' / ' + I.SORULAR.length;
    $('#nhQtext', kok).textContent = q.s;
    $('#nhPfill', kok).style.width = (D.i / I.SORULAR.length * 100) + '%';
    $('#nhGeri', kok).hidden = D.i === 0;

    var kutu = $('#nhOpts', kok); kutu.innerHTML = '';
    q.c.forEach(function (o) {
      var b = el('button','nh-opt'); b.type='button';
      b.innerHTML = '<span class="nh-opt-mark"></span><span>'+esc(o.m)+'</span>';
      if (D.cevap[q.k] === o.v) b.classList.add('is-picked');
      b.addEventListener('click', function () { cevapla(q.k, o.v, b); });
      kutu.appendChild(b);
    });
    kutu.classList.add('is-fresh');
    /* Mobil: bir önceki cevaba dokunulan yerde kalınca yeni sorunun başlığı ekranın üstünde kalıyordu → soru paneli görünür alana çekilir */
    try {
      var qp = $('#nhQtext', kok); var pnl = (qp && (qp.closest('.nh-soru') || qp.closest('.nh-screen'))) || qp;
      if (pnl) { var qt = pnl.getBoundingClientRect().top; if (qt < 8 || qt > window.innerHeight * 0.6) { var hedefY = Math.max(0, qt + window.pageYOffset - 16); window.scrollTo({ top: hedefY, behavior: 'smooth' }); } }
    } catch (e) {}
    var coz = function () { kutu.classList.remove('is-fresh'); };
    window.addEventListener('mousemove', coz, { once:true, passive:true });
    window.addEventListener('touchstart', coz, { once:true, passive:true });
  }

  function cevapla(k, v, btn) {
    if (btn.dataset.busy) return;
    D.cevap[k] = v;
    $$('.nh-opt', kok).forEach(function (n) { n.classList.remove('is-picked'); n.dataset.busy='1'; });
    btn.classList.add('is-picked');
    $('#nhPfill', kok).style.width = ((D.i+1) / I.SORULAR.length * 100) + '%';
    setTimeout(function () {
      if (D.i < I.SORULAR.length - 1) { D.i++; soruCiz(); }
      else { ekran('hesap'); hesapCalistir(); }
    }, 190);
  }
  var geriBtn = $('#nhGeri', kok);
  if (geriBtn) geriBtn.addEventListener('click', function () { if (D.i>0) { D.i--; soruCiz(); } });

  /* ---------------------------------------------------------- hesap */
  function acilariBul(gez) {
    var ad = Object.keys(gez), liste = [];
    for (var i = 0; i < ad.length; i++) {
      for (var j = i+1; j < ad.length; j++) {
        var f = Math.abs(((gez[ad[i]].boylam - gez[ad[j]].boylam + 540) % 360) - 180);
        f = 180 - Math.abs(180 - Math.abs(gez[ad[i]].boylam - gez[ad[j]].boylam) % 360);
        var fark = Math.abs(gez[ad[i]].boylam - gez[ad[j]].boylam) % 360;
        if (fark > 180) fark = 360 - fark;
        I.ACI.forEach(function (t) {
          var sapma = Math.abs(fark - t.derece);
          if (sapma <= t.tolerans) {
            liste.push({ g1: ad[i], g2: ad[j], ad: t.ad, tur: t.tur, metin: t.metin, sapma: sapma });
          }
        });
      }
    }
    /* en dar açılar önce (en güçlüler) */
    liste.sort(function (a,b) { return a.sapma - b.sapma; });
    return liste;
  }

  function dengeHesapla(gez, yukselenBurcNo) {
    var el = { 'Ateş':0,'Toprak':0,'Hava':0,'Su':0 }, ni = { 'Öncü':0,'Sabit':0,'Değişken':0 };
    Object.keys(gez).forEach(function (k) {
      var b = I.BURC[gez[k].burcNo];
      el[b.element]++; ni[b.nitelik]++;
    });
    /* yükselen de sayılır — kişinin dışa dönük tarzı */
    var yb = I.BURC[yukselenBurcNo];
    el[yb.element]++; ni[yb.nitelik]++;
    return { element: el, nitelik: ni };
  }

  function hesapCalistir() {
    var basamak = $$('#nhSteps li', kok);
    basamak.forEach(function (n) { n.classList.remove('is-on'); });
    var i = 0;
    var t = setInterval(function () {
      if (i > 0 && basamak[i-1]) basamak[i-1].classList.remove('is-on');
      if (i < basamak.length) { basamak[i].classList.add('is-on'); i++; }
      else {
        clearInterval(t);
        var h = A.harita(D.yil, D.ay, D.gun, D.saat, D.dakika, D.sehir.tz, D.sehir.lat, D.sehir.lon);
        h.acilar = acilariBul(h.gezegenler);
        h.denge = dengeHesapla(h.gezegenler, h.yukselenBurcNo);
        D.harita = h;
        sonucCiz();
        ekran('sonuc');
        panelKaydet();
      }
    }, 560);
  }

  /* ---------------------------------------------------------- sepet (tema-native) */
  var CART_SECTIONS = [
    { id:'cart-icon-bubble', selector:'#cart-icon-bubble' },
    { id:'mobile-cart-icon-bubble', selector:'#mobile-cart-icon-bubble' },
    { id:'cart-drawer', selector:'#CartDrawer' }
  ];
  function cartSections() {
    try { var s = Alpine.store('xCartHelper').getSectionsToRender(); if (s && s.length) return s; } catch(e) {}
    return CART_SECTIONS;
  }
  function swapCart(secs, payload) {
    if (!payload) return false;
    var ok = false;
    secs.forEach(function (s) {
      try {
        var e = document.querySelector(s.selector);
        if (e && payload[s.id]) {
          var src = new DOMParser().parseFromString(payload[s.id],'text/html').querySelector(s.selector);
          if (src) { e.innerHTML = src.innerHTML; ok = true; }
        }
      } catch(err) {}
    });
    return ok;
  }
  function syncCart() {
    try { var sp = document.querySelector('#cart-icon-bubble span');
      if (sp) Alpine.store('xCartHelper').currentItemCount = parseInt(sp.textContent)||0; } catch(e) {}
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }
  var etiketYazildi = false;
  function sepetEtiketi() {
    if (etiketYazildi || !D.testId || !D.harita) return;
    etiketYazildi = true;
    var h = D.harita;
    fetch('/cart/update.js', { method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ attributes: {
        'Doğum Haritası': D.testId,
        'Güneş': h.gezegenler.gunes.burc,
        'Yükselen': h.yukselenBurc
      }})}).catch(function(){});
  }
  function sepetBildir(btn) {
    if (!VERI.sepet || !D.testId) return;
    var kart = btn && btn.closest ? btn.closest('.nh-p') : null;
    var p = kart ? URUN_HAR[kart.dataset.kid] : null;
    try {
      fetch(VERI.sepet, { method:'POST', mode:'cors', keepalive:true,
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ test_kod: D.testId, store: (VERI.store || 'saff'), urun: p ? p.t : '' }) }).catch(function(){});
    } catch(e) {}
  }

  function sepeteEkle(vid, btn, eski) {
    btn.disabled = true; btn.textContent = 'EKLENİYOR…';
    var secs = cartSections();
    return fetch('/cart/add.js', { method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
      body: JSON.stringify({ id: parseInt(vid,10), quantity:1,
        sections: secs.map(function(s){return s.id;}), sections_url: window.location.pathname })})
      .then(function (r) { return r.json().then(function (j) { return {ok:r.ok, j:j}; }); })
      .then(function (res) {
        if (!res.ok) { btn.textContent = 'STOKTA YOK';
          setTimeout(function(){btn.textContent=eski;btn.disabled=false;},1800); return; }
        btn.textContent = 'EKLENDİ ✓'; btn.classList.add('is-ok');
        if (res.j && res.j.sections && swapCart(secs,res.j.sections)) syncCart();
        sepetEtiketi();
        sepetBildir(btn);
        try { Alpine.store('xMiniCart').openCart(); } catch(e) {}
        setTimeout(function(){btn.textContent=eski;btn.disabled=false;btn.classList.remove('is-ok');},2200);
      }).catch(function () {
        btn.textContent='HATA'; setTimeout(function(){btn.textContent=eski;btn.disabled=false;},1800);
      });
  }

  /* ---------------------------------------------------------- ürün kartları */
  var URUN_SAY = 0, URUN_HAR = {};
  function urunler(handle, adet, etiket) {
    var liste = (URUN[handle] || []).slice(0, adet || 4);
    if (!liste.length) return '';
    var h = '<div class="nh-products">';
    liste.forEach(function (p) {
      var kid = 'nhp' + (++URUN_SAY); URUN_HAR[kid] = p;
      var vs = p.v || [];
      h += '<div class="nh-p" data-kid="'+kid+'">' +
           '<a class="nh-p-link" href="'+esc(p.u)+'">' +
           '<div class="nh-p-img">' +
           (p.g ? '<img src="'+esc(p.g)+'" alt="'+esc(p.t)+'" loading="lazy" width="400" height="400">' : '') +
           (etiket ? '<span class="nh-p-tag">'+esc(etiket)+'</span>' : '') + '</div>' +
           '<div class="nh-p-title">'+esc(p.t)+'</div>' +
           '<div class="nh-p-price">' + (p.k && p.k>p.f ? '<del>'+paraFmt(p.k,PARA)+'</del>' : '') +
           paraFmt(p.f,PARA) + '</div></a>';
      if (vs.length) {
        h += '<button type="button" class="nh-add" data-kid="'+kid+'">Sepete Ekle</button>';
        if (vs.length > 1) {
          h += '<div class="nh-sizes" hidden><span class="nh-sizes-lbl">'+esc(p.o||'Beden')+' seçin</span><div class="nh-sizes-row">';
          vs.forEach(function (v) { h += '<button type="button" class="nh-size" data-kid="'+kid+'" data-vid="'+v.i+'">'+esc(v.t)+'</button>'; });
          h += '</div></div>';
        }
      } else {
        h += '<a class="nh-add" href="'+esc(p.u)+'">Ürünü İncele</a>';
      }
      h += '</div>';
    });
    return h + '</div>';
  }
  function urunOlaylari(kap) {
    $$('.nh-add[data-kid]', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = URUN_HAR[b.dataset.kid]; if (!p) return;
        var vs = p.v || [];
        if (vs.length === 1) { sepeteEkle(vs[0].i, b, 'Sepete Ekle'); return; }
        var kutu = b.parentNode.querySelector('.nh-sizes');
        if (kutu) { var acik = !kutu.hidden; kutu.hidden = acik; b.textContent = acik ? 'Sepete Ekle' : 'Kapat'; }
      });
    });
    $$('.nh-size[data-vid]', kap).forEach(function (b) {
      b.addEventListener('click', function () {
        var kart = b.closest('.nh-p'), ana = kart ? kart.querySelector('.nh-add') : null;
        $$('.nh-size', kart).forEach(function (x) { x.classList.remove('is-picked'); });
        b.classList.add('is-picked');
        sepeteEkle(b.dataset.vid, ana || b, 'Sepete Ekle').then(function () {
          var k = kart ? kart.querySelector('.nh-sizes') : null; if (k) k.hidden = true;
        });
      });
    });
  }

  /* ---------------------------------------------------------- panel + e-posta */
  function kaynakBul() {
    try {
      var q = new URLSearchParams(location.search), u = q.get('utm_source')||q.get('ref');
      if (u) return String(u).slice(0,60);
      if (!document.referrer) return 'dogrudan';
      var hh = new URL(document.referrer).hostname.replace(/^www\./,'');
      return hh === location.hostname.replace(/^www\./,'') ? 'site-ici' : hh.slice(0,60);
    } catch(e) { return ''; }
  }
  function panelKaydet() {
    if (!VERI.panel || !D.harita) return;
    var h = D.harita;
    var gz = {}; Object.keys(h.gezegenler).forEach(function (k) { gz[k] = h.gezegenler[k].burc; });
    try {
      fetch(VERI.panel, { method:'POST', mode:'cors', keepalive:true,
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          test_kod: D.testId, tur: 'dogum-haritasi', store: (VERI.store || 'saff'),
          ad: D.ad, soyad: D.soyad, email: D.email,
          dogum_gun: D.gun, dogum_ay: D.ay, dogum_yil: D.yil,
          dogum_saat: D.saatBilinmiyor ? null : (D.saat + ':' + (D.dakika<10?'0':'') + D.dakika),
          dogum_yer: D.sehir.ad,
          burc: h.gezegenler.gunes.burc, ay_burc: h.gezegenler.ay.burc, yukselen: h.yukselenBurc,
          gezegenler: gz, cevaplar: D.cevap,
          cihaz: window.matchMedia('(max-width:820px)').matches ? 'mobil' : 'masaustu',
          kaynak: kaynakBul()
        })}).then(function(r){return r.json();}).then(function(res){ if(res&&res.kupon){ kuponGoster(res.kupon); } }).catch(function(){});
    } catch(e) {}
  }
  function kuponGoster(kod){ if(!kod)return; if(document.getElementById('nhKupon'))return;
    var pr=document.querySelector('.nh-products'); if(!pr)return;
    var box=document.createElement('div'); box.id='nhKupon'; box.className='nh-kupon';
    box.innerHTML='<span class="nh-kupon-et">🎁 Sana Özel Hediye</span>'+
      '<p class="nh-kupon-a">Doğum haritanı çıkardın — <b>tüm sepetine %10 indirim</b>. 1 hafta geçerli · tek kullanımlık.</p>'+
      '<div class="nh-kupon-kod"><code>'+esc(kod)+'</code><button type="button" class="nh-kupon-kopya" id="nhKuponKopya">Kopyala</button></div>';
    pr.parentNode.insertBefore(box,pr);
    var kb=document.getElementById('nhKuponKopya'); if(kb)kb.onclick=function(){ var ok=false; try{ navigator.clipboard.writeText(kod); ok=true; }catch(e){} if(!ok){try{var tmp=document.createElement('textarea');tmp.value=kod;document.body.appendChild(tmp);tmp.select();document.execCommand('copy');tmp.remove();}catch(e2){}} var t=kb.textContent; kb.textContent='✓ Kopyalandı'; kb.classList.add('ok'); setTimeout(function(){kb.textContent=t;kb.classList.remove('ok');},1900); };
  }


  /* ---------------------------------------------------------- derin katman */
  function onurDurum(gezKey, burcNo) {
    var o = I.ONUR[gezKey]; if (!o) return 'yok';
    if (o.ev.indexOf(burcNo) > -1)    return 'ev';
    if (o.yuc.indexOf(burcNo) > -1)   return 'yuc';
    if (o.zarar.indexOf(burcNo) > -1) return 'zarar';
    if (o.dusus.indexOf(burcNo) > -1) return 'dusus';
    return 'yok';
  }
  /* Açılır detay — meraklı kullanıcı için; varsayılan kapalı. */
  function derin(baslik, icHtml) {
    return '<details class="nh-derin"><summary>' + esc(baslik || 'Daha derine in') +
           '</summary><div class="nh-derin-ic">' + icHtml + '</div></details>';
  }
  function dereceYaz(d) {
    var tam = Math.floor(d), dk = Math.round((d - tam) * 60);
    if (dk === 60) { tam++; dk = 0; }
    return tam + '° ' + (dk < 10 ? '0' : '') + dk + '\'';
  }
  /* Bir gezegen için derin blok */
  function gezegenDerin(k, gz, h) {
    var m = I.GEZEGEN[k], b = I.BURC[gz.burcNo], ev = I.EV[gz.ev - 1];
    var dur = onurDurum(k, gz.burcNo), om = I.ONUR_METIN[dur];
    var yonEv = I.yonettigiEvler(k, h.yukselenBurcNo, I.YONETICI);
    var ic = '';
    ic += '<p><strong>Tam konum:</strong> ' + esc(b.ad) + ' burcunun ' + dereceYaz(gz.derece) +
          ' derecesi · ' + gz.ev + '. ev</p>';
    ic += '<p><strong>Onur durumu — ' + esc(om.ad) + ':</strong> ' + esc(om.m) + '</p>';
    if (yonEv.length) {
      ic += '<p><strong>Haritanda yönettiği alanlar:</strong> ' +
            yonEv.map(function (e) { return e + '. ev (' + esc(I.EV[e-1].ad) + ')'; }).join(', ') +
            '. Yani bu gezegenin durumu, o alanların gidişatını da etkiler.</p>';
    }
    ic += '<p><strong>Evin tam konusu:</strong> ' + esc(ev.konu) + '.</p>';
    if (I.GUNLUK[k]) ic += '<p><strong>Gündelik hayatta:</strong> ' + esc(I.GUNLUK[k]) + '</p>';
    return derin('Daha derine in — ' + m.ad, ic);
  }

  /* ---------------------------------------------------------- SONUÇ */
  function sonucCiz() {
    var h = D.harita, kap = $('#nhSonuc', kok);
    var gunesB = I.BURC[h.gezegenler.gunes.burcNo],
        ayB    = I.BURC[h.gezegenler.ay.burcNo],
        yukB   = I.BURC[h.yukselenBurcNo];
    var odak = D.cevap.alan || 'ruh';
    var out = '';

    /* — başlık */
    out += '<div class="nh-hero">';
    /* SAFF: güneş burcunun 3B amblemi (kie.ai) */
    if (VERI.burcimg && VERI.burcimg[gunesB.koleksiyon]) out += '<div class="nh-burc-portre"><img src="' + esc(VERI.burcimg[gunesB.koleksiyon]) + '" alt="' + esc(gunesB.ad) + '" loading="lazy"></div>';
    out += '<div class="nh-eyebrow">Doğum Haritan Hazır</div>';
    out += '<h1>' + esc(D.ad) + (D.soyad ? ' ' + esc(D.soyad) : '') + ',<br><em>' +
           esc(gunesB.ad) + ' güneşi, ' + esc(ayB.ad) + ' ayı, ' + esc(yukB.ad) + ' yükseleni.</em></h1>';
    out += '<p class="nh-lede" style="max-width:640px;margin:0 auto">' +
           esc(D.gun + ' ' + AYLAR[D.ay-1] + ' ' + D.yil) +
           (D.saatBilinmiyor ? '' : ' · ' + (D.saat<10?'0':'')+D.saat + ':' + (D.dakika<10?'0':'')+D.dakika) +
           ' · ' + esc(D.sehir.ad) + '</p>';
    out += '<div class="nh-uclu">' +
      '<div><div class="nh-u-ikon">☉</div><dt>Güneş</dt><dd>' + esc(gunesB.ad) + '<small>' + esc(gunesB.element) + ' · ' + h.gezegenler.gunes.derece.toFixed(0) + '°</small></dd></div>' +
      '<div><div class="nh-u-ikon">☽</div><dt>Ay</dt><dd>' + esc(ayB.ad) + '<small>' + esc(ayB.element) + ' · ' + h.gezegenler.ay.derece.toFixed(0) + '°</small></dd></div>' +
      '<div><div class="nh-u-ikon">↑</div><dt>Yükselen</dt><dd>' + esc(yukB.ad) + '<small>' + esc(yukB.element) + ' · ' + h.yukselenDerece.toFixed(0) + '°</small></dd></div>' +
      '</div>';
    if (D.saatBilinmiyor) {
      out += '<p class="nh-lede" style="font-size:13px;max-width:600px;margin:18px auto 0;color:var(--ink-faint)">' +
             'Doğum saatini bilmediğin için harita öğlen 12:00’a göre kuruldu. Güneş ve gezegen burçların doğru; ' +
             '<strong>yükselen ve ev yerleşimleri tahminîdir</strong> — saatini öğrenirsen testi tekrar çözebilirsin.</p>';
    }
    out += '</div>';

    /* — 3B çark */
    out += '<section class="nh-sec"><div class="nh-sec-head"><h2>Gökyüzü o an</h2>' +
           '<p>Doğduğun anda gezegenler gökyüzünde tam olarak buradaydı. Çarkı parmağınla ya da fareyle ' +
           'döndürebilirsin. Dıştaki halka burçları, içteki numaralar hayat alanlarını (evleri), ' +
           'ortadaki çizgiler gezegenler arasındaki açıları gösterir.</p></div>';
    out += '<div class="nh-cark-sar"><div><div class="nh-cark"><canvas id="nhCark"></canvas></div>' +
           '<div class="nh-cark-not">Sürükleyerek döndür</div></div><div class="nh-gezlist" id="nhGezList"></div></div></section>';

    /* — üç temel */
    out += '<section class="nh-sec"><div class="nh-sec-head"><h2>Üç temelin</h2>' +
           '<p>Astrolojide kişiliğin omurgasını üç yerleşim taşır: Güneş kim olduğunu, Ay ne hissettiğini, ' +
           'Yükselen dünyaya hangi yüzle çıktığını anlatır.</p></div>';
    out += '<div class="nh-kart"><div class="nh-alt">☉ Güneş · ' + esc(gunesB.ad) + ' · ' + h.gezegenler.gunes.ev + '. ev</div>' +
           '<h3>Öz benliğin</h3><p>' + esc(gunesB.oz) + '</p>' +
           '<p style="color:var(--ink-faint);font-size:14px">Bu enerji haritanda <strong style="color:var(--gold-2);font-weight:400">' +
           esc(I.EV[h.gezegenler.gunes.ev-1].ad) + '</strong> alanında yoğunlaşıyor — ' +
           esc(I.EV[h.gezegenler.gunes.ev-1].konu) + '.</p>' +
           gezegenDerin('gunes', h.gezegenler.gunes, h) + '</div>';
    out += '<div class="nh-kart"><div class="nh-alt">☽ Ay · ' + esc(ayB.ad) + ' · ' + h.gezegenler.ay.ev + '. ev</div>' +
           '<h3>Duygusal doğan</h3><p>' + esc(ayB.duygu) + '</p>' +
           '<p style="color:var(--ink-faint);font-size:14px">Duygusal ihtiyacın <strong style="color:var(--gold-2);font-weight:400">' +
           esc(I.EV[h.gezegenler.ay.ev-1].ad) + '</strong> alanında beslenir.</p>' +
           gezegenDerin('ay', h.gezegenler.ay, h) + '</div>';
    out += '<div class="nh-kart"><div class="nh-alt">↑ Yükselen · ' + esc(yukB.ad) + '</div>' +
           '<h3>Dünyaya dönük yüzün</h3><p>' + esc(yukB.maske) + '</p>' +
           derin('Daha derine in — Yükselen',
             '<p><strong>Tam konum:</strong> ' + esc(yukB.ad) + ' burcunun ' + dereceYaz(h.yukselenDerece) + ' derecesi.</p>' +
             '<p><strong>Ne demek:</strong> Yükselen, doğduğun anda doğu ufkunda yükselen burçtur. Yaklaşık iki saatte ' +
             'bir değişir — bu yüzden aynı gün doğan iki kişinin yükseleni farklı olabilir ve haritaları bambaşka görünür.</p>' +
             '<p><strong>Haritanın çatısı:</strong> Yükselenin burcu 1. evini belirler; diğer on bir ev bunun ardından ' +
             'sıralanır. Yani yükselen değişirse tüm ev yerleşimleri değişir.</p>' +
             '<p><strong>Yöneticin:</strong> ' + esc(I.GEZEGEN[I.YONETICI[h.yukselenBurcNo]].ad) + ' — bu gezegen senin ' +
             '“harita sahibin” sayılır; nerede duruyorsa hayatının genel yönü oradan renk alır. ' +
             'Haritanda ' + esc(I.BURC[h.gezegenler[I.YONETICI[h.yukselenBurcNo]].burcNo].ad) + ' burcunda, ' +
             h.gezegenler[I.YONETICI[h.yukselenBurcNo]].ev + '. evde.</p>') + '</div>';
    out += '</section>';

    /* — gezegenler */
    out += '<section class="nh-sec"><div class="nh-sec-head"><h2>Gezegenlerin</h2>' +
           '<p>Her gezegen hayatının bir işlevini yönetir; bulunduğu burç o işlevin nasıl çalıştığını söyler.</p></div>';
    ['merkur','venus','mars','jupiter','saturn'].forEach(function (k) {
      var gz = h.gezegenler[k], b = I.BURC[gz.burcNo], meta = I.GEZEGEN[k];
      out += '<div class="nh-kart" style="padding:22px 24px;margin-bottom:12px">' +
             '<div class="nh-alt">' + esc(meta.sembol) + ' ' + esc(meta.ad) + ' · ' + esc(b.ad) + ' · ' + gz.ev + '. ev</div>' +
             '<h3 style="font-size:21px">' + esc(meta.kisa) + '</h3>' +
             '<p style="margin-bottom:0">' + esc(meta.ad) + ' senin ' + esc(meta.islev) + '. ' +
             esc(b.ad) + ' burcunda olduğu için bu taraf <strong style="color:var(--ink);font-weight:400">' +
             esc(b.ton) + '</strong> işliyor. Etkisini en çok <strong style="color:var(--gold-2);font-weight:400">' +
             esc(I.EV[gz.ev-1].ad) + '</strong> alanında — ' + esc(I.EV[gz.ev-1].konu) + ' — hissedersin.</p>' +
             gezegenDerin(k, gz, h) + '</div>';
    });
    out += '</section>';

    /* — element dengesi */
    var el = h.denge.element, top = 0;
    Object.keys(el).forEach(function (k) { top += el[k]; });
    var enCok = Object.keys(el).sort(function(a,b){return el[b]-el[a];})[0];
    var enAz  = Object.keys(el).sort(function(a,b){return el[a]-el[b];})[0];
    out += '<section class="nh-sec"><div class="nh-sec-head"><h2>Element dengen</h2>' +
           '<p>Sekiz yerleşimin (yedi gezegen + yükselen) hangi elementlere dağıldığı, mizacının ana rengini verir.</p></div>';
    out += '<div class="nh-denge">';
    var ELR = { 'Ateş':'var(--ates)','Toprak':'var(--toprak)','Hava':'var(--hava)','Su':'var(--su)' };
    ['Ateş','Toprak','Hava','Su'].forEach(function (k) {
      out += '<div class="nh-el"><div class="nh-el-ad">'+esc(k)+'</div>' +
             '<div class="nh-el-bar"><i data-w="'+Math.round(el[k]/top*100)+'" style="background:'+ELR[k]+'"></i></div>' +
             '<div class="nh-el-say">'+el[k]+'</div></div>';
    });
    out += '</div>';
    out += '<div class="nh-kart" style="margin-top:20px"><p>' + esc(I.ELEMENT[enCok].baskin) + '</p>';
    if (el[enAz] <= 1) out += '<p>' + esc(I.ELEMENT[enAz].eksik) + '</p>';
    var ni = h.denge.nitelik;
    var enNi = Object.keys(ni).sort(function(a,b){return ni[b]-ni[a];})[0];
    out += '<p style="color:var(--ink-faint);font-size:14px">' + esc(I.NITELIK[enNi]) + '</p>';
    var elIc = '<p><strong>Nasıl sayılıyor?</strong> Yedi gezegenin ve yükselenin bulunduğu burçların elementleri ' +
               'toplanır — toplam sekiz yerleşim. Bir elementte 3 ve üzeri “baskın”, 1 ve altı “zayıf” sayılır.</p>' +
               '<p><strong>Senin dağılımın:</strong> ' +
               ['Ateş','Toprak','Hava','Su'].map(function (k) { return k + ' ' + el[k]; }).join(' · ') + '</p>' +
               '<p><strong>Nitelik dağılımı:</strong> ' +
               ['Öncü','Sabit','Değişken'].map(function (k) { return k + ' ' + ni[k]; }).join(' · ') +
               '. Öncü burçlar başlatır, sabit burçlar sürdürür, değişken burçlar uyum sağlar.</p>' +
               '<p><strong>Zayıf element ne demek?</strong> Eksik olduğun element “sende yok” demek değil; ' +
               'o alanın sende kendiliğinden gelmediği, bilinçli çaba istediği anlamına gelir. ' +
               'Çoğu kişi zayıf elementini zamanla en bilinçli kullandığı taraf hâline getirir.</p>';
    out += derin('Daha derine in — element hesabı', elIc) + '</div>';
    out += '</section>';

    /* — açılar */
    if (h.acilar.length) {
      out += '<section class="nh-sec"><div class="nh-sec-head"><h2>Gezegen açıların</h2>' +
             '<p>Gezegenler arasındaki açılar, iç dünyandaki iş birliklerini ve gerilimleri anlatır. ' +
             'En belirgin olanlar aşağıda.</p></div><div class="nh-aci">';
      h.acilar.slice(0, 7).forEach(function (a) {
        var m1 = I.GEZEGEN[a.g1], m2 = I.GEZEGEN[a.g2];
        var sinif = a.tur === 'gerilim' ? 't-gerilim' : (a.tur === 'akış' ? 't-akis' : 't-guclu');
        out += '<div class="nh-aci-satir"><span class="nh-aci-ad '+sinif+'">'+esc(a.ad)+'</span>' +
               '<span class="nh-aci-metin"><b>'+esc(m1.sembol+' '+m1.ad)+'</b> ile <b>'+esc(m2.sembol+' '+m2.ad)+'</b> arasında ' +
               esc(a.metin) + ' var. Yani ' + esc(m1.islev.split(',')[0]) + ' ile ' +
               esc(m2.islev.split(',')[0]) + ' birbirini etkiliyor.</span></div>';
      });
      out += '</div>';
      /* açılar için tek bir derin blok — teknik ayrıntı isteyene */
      var aciIc = '<p>Açı, iki gezegen arasındaki ekliptik mesafedir. Mesafe ne kadar tama yakınsa etki o kadar güçlüdür.</p>';
      h.acilar.slice(0, 7).forEach(function (a) {
        var m1 = I.GEZEGEN[a.g1], m2 = I.GEZEGEN[a.g2];
        aciIc += '<p><strong>' + esc(m1.ad + ' – ' + m2.ad + ' · ' + a.ad) + '</strong><br>' +
                 'Sapma ' + a.sapma.toFixed(1) + '° — ' + esc(I.aciSiki(a.sapma)) + '.<br>' +
                 esc(I.ACI_DERIN[a.ad] || '') + '</p>';
      });
      out += derin('Daha derine in — açıların tekniği', aciIc);
      out += '</section>';
    }

    /* — sorduğun alan: DERİN OKUMA
       Beş soru sorup tek cümle vermek yetersizdi. Burada alanın evi, evin burcu,
       evdeki gezegenler ve evin YÖNETİCİSİ birlikte okunuyor (geleneksel teknik),
       ayrıca güç/zorluk/hal/niyet cevaplarının hepsi karşılık buluyor. */
    var alanBilgi = I.ALAN[odak];
    if (alanBilgi) {
      var aEv = alanBilgi.ev;
      var aEvBurcNo = (h.yukselenBurcNo + aEv - 1) % 12;     // Whole Sign
      var aEvBurc = I.BURC[aEvBurcNo];
      var evMeta = I.EV[aEv - 1];

      out += '<section class="nh-sec"><div class="nh-sec-head"><h2>Sorduğun alan: ' + esc(alanBilgi.ad) + '</h2>' +
             '<p>' + esc(alanBilgi.giris) + '</p></div>';

      /* 1) evin burcu */
      out += '<div class="nh-kart"><div class="nh-alt">' + aEv + '. ev · ' + esc(evMeta.ad) + ' · ' + esc(aEvBurc.ad) + ' burcunda</div>' +
             '<h3>Bu alana yaklaşımın</h3>' +
             '<p>' + esc(alanBilgi.evGiris) + '</p>' +
             '<p>Senin ' + aEv + '. evin <strong style="color:var(--gold-2);font-weight:400">' + esc(aEvBurc.ad) +
             '</strong> burcunda. Yani bu alana <strong style="color:var(--ink);font-weight:400">' + esc(aEvBurc.ton) +
             '</strong> bir tavırla yaklaşıyorsun.</p>' +
             '<p>' + esc(alanBilgi.element[aEvBurc.element] || '') + '</p></div>';

      /* 2) bu evde gezegen var mı — en değerli bilgi */
      var evdekiler = Object.keys(h.gezegenler).filter(function (k) { return h.gezegenler[k].ev === aEv; });
      if (evdekiler.length) {
        out += '<div class="nh-kart"><div class="nh-alt">Bu evde duran gezegenler</div>' +
               '<h3>Alanı doğrudan besleyen güçler</h3>' +
               '<p>' + aEv + '. evinde ' + evdekiler.length + ' gezegen var — bu, hayatının bu alanına ' +
               'ortalamadan daha fazla enerji aktığı anlamına gelir.</p>';
        evdekiler.forEach(function (k) {
          var gz = h.gezegenler[k], m = I.GEZEGEN[k], bb = I.BURC[gz.burcNo];
          out += '<p style="padding-left:16px;border-left:1px solid var(--line)"><strong style="color:var(--gold-2);font-weight:400">' +
                 esc(m.sembol + ' ' + m.ad) + ' · ' + esc(bb.ad) + '</strong><br>' +
                 esc(m.ad) + ' senin ' + esc(m.islev) + '. Bu alanda ' + esc(bb.ton) + ' bir biçimde devreye giriyor.</p>';
        });
        out += '</div>';
      } else {
        out += '<div class="nh-kart"><div class="nh-alt">Bu evde gezegen yok</div>' +
               '<p style="margin-bottom:0">' + esc(alanBilgi.bosEv) + '</p></div>';
      }

      /* 3) evin yöneticisi nerede — geleneksel astrolojinin kilit tekniği */
      var yonKey = I.YONETICI[aEvBurcNo];
      var yon = h.gezegenler[yonKey];
      if (yon) {
        var yonMeta = I.GEZEGEN[yonKey], yonBurc = I.BURC[yon.burcNo], yonEv = I.EV[yon.ev - 1];
        out += '<div class="nh-kart"><div class="nh-alt">Evin yöneticisi · ' + esc(yonMeta.sembol + ' ' + yonMeta.ad) + '</div>' +
               '<h3>Bu alan hayatının neresine bağlı?</h3>' +
               '<p>' + aEv + '. evin ' + esc(aEvBurc.ad) + ' burcunda olduğu için bu alanın yöneticisi ' +
               '<strong style="color:var(--gold-2);font-weight:400">' + esc(yonMeta.ad) + '</strong>. ' +
               'Yönetici gezegenin nerede durduğu, o alanın hayatının hangi bölgesinden beslendiğini söyler.</p>' +
               '<p>Senin ' + esc(yonMeta.ad) + '’in <strong style="color:var(--ink);font-weight:400">' + esc(yonBurc.ad) +
               '</strong> burcunda ve <strong style="color:var(--ink);font-weight:400">' + yon.ev + '. evde</strong> — ' +
               esc(yonEv.ad).toLocaleLowerCase('tr') + ' alanında. Yani ' + esc(alanBilgi.ad.toLocaleLowerCase('tr')) +
               ' konusundaki gelişmen, ' + esc(yonEv.konu) + ' ile doğrudan bağlantılı ilerliyor.</p></div>';
      }

      /* 4) alanın ana gezegenleri */
      alanBilgi.anaGezegen.forEach(function (k) {
        var gz = h.gezegenler[k]; if (!gz) return;
        var m = I.GEZEGEN[k], bb = I.BURC[gz.burcNo], ee = I.EV[gz.ev - 1];
        out += '<div class="nh-kart" style="padding:22px 24px;margin-bottom:12px">' +
               '<div class="nh-alt">' + esc(m.sembol + ' ' + m.ad) + ' · ' + esc(bb.ad) + ' · ' + gz.ev + '. ev</div>' +
               '<p style="margin-bottom:0">' + esc(m.ad) + ' bu soruda kilit rol oynar: ' + esc(m.islev) + '. ' +
               esc(bb.ad) + ' burcunda olduğu için ' + esc(bb.ton) + ' işliyor; etkisini en çok ' +
               esc(ee.ad).toLocaleLowerCase('tr') + ' alanında hissedersin.</p></div>';
      });

      /* 5) güçlü tarafın */
      var gucSec = I.GUC_METIN[D.cevap.guc];
      if (gucSec && h.gezegenler[gucSec.g]) {
        var gg = h.gezegenler[gucSec.g], gm = I.GEZEGEN[gucSec.g], gb = I.BURC[gg.burcNo];
        out += '<div class="nh-kart"><div class="nh-alt">Güvendiğin taraf</div>' +
               '<h3>Bu gücün haritadaki yeri</h3>' +
               '<p>' + esc(gucSec.m) + ' Haritanda ' + esc(gm.ad) + ' <strong style="color:var(--gold-2);font-weight:400">' +
               esc(gb.ad) + '</strong> burcunda ve ' + gg.ev + '. evde. Bu da o gücün ' + esc(gb.ton) +
               ' bir renkte çalıştığı ve en çok ' + esc(I.EV[gg.ev-1].ad).toLocaleLowerCase('tr') +
               ' alanında işine yaradığı anlamına gelir.</p></div>';
      }

      /* 6) zorlandığın + pratik öneri */
      var zor = I.ZORLUK_METIN[D.cevap.zorluk];
      if (zor && h.gezegenler[zor.g]) {
        var zg = h.gezegenler[zor.g], zm = I.GEZEGEN[zor.g], zb = I.BURC[zg.burcNo];
        out += '<div class="nh-kart"><div class="nh-alt">Seni yoran şey</div>' +
               '<h3>Nereden geliyor?</h3>' +
               '<p>' + esc(zor.m) + '</p>' +
               '<p>Senin ' + esc(zm.ad) + '’in <strong style="color:var(--ink);font-weight:400">' + esc(zb.ad) +
               '</strong> burcunda — ' + esc(zb.ton) + '. Bu, zorlandığın noktanın neden tam da böyle ' +
               'hissettirdiğini açıklar.</p>' +
               '<p style="padding:14px 16px;border-left:2px solid var(--gold);color:var(--ink);margin-bottom:0">' +
               '<strong style="font-weight:400">Bu hafta deneyebilirsin:</strong> ' + esc(zor.oneri) + '</p></div>';
      }

      /* 7) şu anki halin + niyet */
      var kapanis = '';
      if (D.cevap.hal && I.HAL_METIN[D.cevap.hal]) kapanis += '<p>' + esc(I.HAL_METIN[D.cevap.hal]) + '</p>';
      if (D.cevap.niyet && I.NIYET_METIN[D.cevap.niyet]) kapanis += '<p style="margin-bottom:0">' + esc(I.NIYET_METIN[D.cevap.niyet]) + '</p>';
      if (kapanis) out += '<div class="nh-kart"><div class="nh-alt">Son söz</div>' + kapanis + '</div>';

      out += '</section>';
    }

    /* — taş önerileri */
    out += '<section class="nh-sec"><div class="nh-sec-head"><h2>Haritana göre taşların</h2>' +
           '<p>Aşağıdaki öneriler doğrudan haritandan geliyor: güneş burcun, ay burcun, yükselenin ve ' +
           'dengelemen gereken element. Hepsi sertifikalı ve stokta.</p></div>';

    var bloklar = [
      { b: gunesB, baslik: 'Güneş burcun · ' + gunesB.ad, alt: gunesB.taslar + '. ' + gunesB.dengeNotu },
      { b: ayB,    baslik: 'Ay burcun · ' + ayB.ad,       alt: ayB.taslar + '. ' + ayB.dengeNotu },
      { b: yukB,   baslik: 'Yükselenin · ' + yukB.ad,     alt: yukB.taslar + '. ' + yukB.dengeNotu }
    ];
    /* eksik element için o elementin bir burcu */
    if (el[enAz] <= 1) {
      var eksikB = null;
      for (var q = 0; q < 12; q++) if (I.BURC[q].element === enAz) { eksikB = I.BURC[q]; break; }
      if (eksikB) bloklar.push({ b: eksikB, baslik: 'Eksik elementin · ' + enAz,
                                 alt: I.ELEMENT[enAz].tas + '. ' + I.ELEMENT[enAz].eksik });
    }
    var yazildi = {};
    bloklar.forEach(function (x) {
      if (yazildi[x.b.koleksiyon]) return;
      var u = urunler(x.b.koleksiyon, 4, x.b.ad);
      /* SAFF: koleksiyon boşsa taş adlarıyla mağaza aramasından doldurulur (asyncUrunler) */
      if (!u) u = '<div class="nh-products nh-products-async" data-tas="' + esc(x.b.taslar || '') + '" data-etiket="' + esc(x.b.ad) + '"></div>';
      yazildi[x.b.koleksiyon] = 1;
      out += '<div style="margin-bottom:38px"><div class="nh-alt" style="margin-bottom:8px">' + esc(x.baslik) + '</div>' +
             '<p class="nh-lede" style="font-size:14px;margin-bottom:18px">' + esc(x.alt) + '</p>' + u + '</div>';
    });
    /* — Kendin Tasarla yönlendirmesi: haritadan çıkan taşlarla kişiye özel tasarım */
    var tumTas = [];
    [gunesB, ayB, yukB].forEach(function (b) {
      b.taslar.split('·').forEach(function (x) {
        x = x.trim(); if (x && tumTas.indexOf(x) === -1) tumTas.push(x);
      });
    });
    out += '<div class="nh-tasarla">' +
           '<div class="nh-eyebrow" style="margin-bottom:10px">Bir adım ileri</div>' +
           '<h3>Bu taşlarla kendi tasarımını yap</h3>' +
           '<p class="nh-lede" style="max-width:620px;margin:0 auto 6px">Haritandan çıkan taşları hazır bir üründe ' +
           'aramak zorunda değilsin. <strong style="color:var(--ink);font-weight:400">Kendin Tasarla</strong> ile ' +
           'taşları tek tek seçip, ölçünü verip kendine ait bir bileklik kurabilirsin.</p>' +
           '<div class="nh-tas-liste">' +
           tumTas.slice(0, 10).map(function (x) { return '<span>' + esc(x) + '</span>'; }).join('') +
           '</div>' +
           '<p class="nh-lede" style="font-size:13.5px;max-width:560px;margin:0 auto 24px;color:var(--ink-faint)">' +
           'Yukarıdakiler senin güneş, ay ve yükselen burçlarının taşları. Tasarımda bunları birlikte ' +
           'kullanabilir, dilediğini çıkarabilirsin.</p>' +
           '<a class="nh-btn" href="/pages/kendin-tasarla">Kendin Tasarla</a>' +
           '</div>';

    out += '</section>';

    /* — e-posta + dipnot */
    out += '<section class="nh-sec" style="margin-bottom:0">';
    out += '<div class="nh-mail" id="nhMail"><div class="nh-eyebrow" style="margin-bottom:10px">Haritan elinin altında dursun</div>' +
           '<h3>Doğum haritanı e-posta ile gönderelim</h3>' +
           '<p class="nh-lede" style="font-size:14px;max-width:520px;margin:0 auto">Üç temelin, gezegen yerleşimlerin, ' +
           'element dengen ve sana önerdiğimiz taşlar tek bir e-postada.</p>' +
           '<form class="nh-mail-form" id="nhMailForm" novalidate>' +
           '<input class="nh-input" type="email" id="nhMailAdres" placeholder="e-posta adresin" autocomplete="email" ' +
           'inputmode="email" value="' + esc(D.email||'') + '" required>' +
           '<button type="submit" class="nh-btn" id="nhMailBtn">Gönder</button></form>' +
           '<div class="nh-mail-not" id="nhMailNot" role="status"></div></div>';
    out += '<div class="nh-actions"><button type="button" class="nh-btn nh-btn-ghost" id="nhTekrar">Yeni harita çıkar</button></div>';
    out += '<p class="nh-note">Doğum haritası, doğduğun anda gökyüzünün gerçek konumundan hesaplanır — bu sayfadaki ' +
           'gezegen yerleşimleri astronomik olarak doğrudur. Yorumlar ise astrolojinin geleneksel sembol diline dayanır ve ' +
           '<strong>bir kendini tanıma aracıdır</strong>; tıbbi, hukuki ya da finansal tavsiye yerine geçmez. ' +
           'Doğal taşlar bir hastalığı iyileştirmez. Geleceği önceden bildiren bir iddiamız yok — ' +
           'burada anlatılan, senin eğilimlerin.</p>';
    out += '</section>';

    kap.innerHTML = out;
    urunOlaylari(kap);
    asyncUrunler(kap);

    /* gezegen listesi */
    var gl = $('#nhGezList', kap);
    if (gl) {
      var sira = ['gunes','ay','merkur','venus','mars','jupiter','saturn'];
      gl.innerHTML = sira.map(function (k) {
        var gz = h.gezegenler[k], b = I.BURC[gz.burcNo], meta = I.GEZEGEN[k];
        return '<div class="nh-gez"><span class="nh-gez-sem">'+esc(meta.sembol)+'</span>' +
               '<span class="nh-gez-ad">'+esc(meta.ad)+'<small>'+esc(meta.kisa)+'</small></span>' +
               '<span class="nh-gez-burc">'+esc(b.ad)+'<small>'+gz.derece.toFixed(0)+'° · '+gz.ev+'. ev</small></span></div>';
      }).join('') +
      '<div class="nh-gez" style="border-top:1px solid var(--line);margin-top:6px;padding-top:16px">' +
      '<span class="nh-gez-sem">↑</span><span class="nh-gez-ad">Yükselen<small>Dış görünüşün</small></span>' +
      '<span class="nh-gez-burc">'+esc(yukB.ad)+'<small>'+h.yukselenDerece.toFixed(0)+'°</small></span></div>';
    }

    /* 3B çark */
    var cv = $('#nhCark', kap);
    if (cv && C) {
      cark = C.Cark(cv, h, { etkilesim: true });
      cark.cizBir(); cark.basla();
      /* SAFF: WebGL varsa gerçek 3B gök küresi (saff-3d.js); yoksa Canvas çark kalır. */
      if (window.Saff3D && cv.parentNode) {
        var kutu3 = cv.parentNode;
        if (sahne3) { try { sahne3.yok(); } catch (e) {} sahne3 = null; }
        window.Saff3D.natal(kutu3, h, I).then(function (s3) {
          if (cark) { cark.dur(); }
          cv.style.display = 'none'; kutu3.classList.add('is-3d'); sahne3 = s3;
        }).catch(function () {});
      }
    }

    /* element çubukları */
    requestAnimationFrame(function () {
      setTimeout(function () {
        $$('.nh-el-bar i', kap).forEach(function (n) { n.style.width = n.dataset.w + '%'; });
      }, 140);
    });

    /* e-posta */
    var mf = $('#nhMailForm', kap);
    if (mf) mf.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var g = $('#nhMailAdres',kap), b = $('#nhMailBtn',kap), not = $('#nhMailNot',kap);
      var adres = (g.value||'').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(adres)) { not.className='nh-mail-not is-err'; not.textContent='Geçerli bir e-posta adresi yazın.'; return; }
      if (!VERI.eposta) { not.className='nh-mail-not is-err'; not.textContent='Gönderim şu an kapalı.'; return; }
      var eski = b.textContent; b.disabled = true; b.textContent = 'Gönderiliyor…';
      not.className='nh-mail-not'; not.textContent='';
      fetch(VERI.eposta, { method:'POST', mode:'cors', headers:{'Content-Type':'application/json'},
        body: JSON.stringify(epostaGovdesi(adres)) })
        .then(function (r) { return r.json().then(function (j) { return {ok:r.ok,j:j}; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && res.j.message) || 'hata');
          not.className='nh-mail-not is-ok';
          not.textContent='Gönderildi. Birkaç dakika içinde gelmezse spam klasörüne bak.';
          b.textContent='Gönderildi ✓'; g.disabled=true;
        }).catch(function (e) {
          not.className='nh-mail-not is-err';
          not.textContent=(e&&e.message&&e.message!=='hata')?e.message:'Gönderilemedi, biraz sonra tekrar dene.';
          b.disabled=false; b.textContent=eski;
        });
    });

    var tek = $('#nhTekrar', kap);
    if (tek) tek.addEventListener('click', function () {
      if (cark) { cark.dur(); cark = null; }
      if (sahne3) { try { sahne3.yok(); } catch (e) {} sahne3 = null; }
      ekran('kimlik');
    });
  }

  /* SAFF: Liquid koleksiyonu boşsa taş adlarıyla /search/suggest.json'dan ürün kartı kurar (aynı markup, aynı sepet akışı). */
  var ELE_RX = /bebek|çocuk|cocuk|gua ?sha|masaj|tımbıl|timbil|esans|sarkaç|sarkac|pandül|pandul|ham parça|ham parca|ağaç|agac|su şişesi|dekor|hediyelik|anahtarl|magnet|kolye ucu|takı seti|zincir|kabaşon|kaboşon|kabason/i;
  function suggest(q) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { return (((d.resources || {}).results || {}).products || []).filter(function (p) { return !ELE_RX.test(p.title || ''); }); })
      .catch(function () { return []; });
  }
  function urunJs(url) {
    var b = (url || '').split('?')[0]; if (!b) return Promise.resolve(null);
    return fetch(b + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function asyncUrunler(kap) {
    $$('.nh-products-async', kap).forEach(function (kutu) {
      var taslar = (kutu.dataset.tas || '').split('·').map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 4);
      if (!taslar.length) { kutu.parentNode.removeChild(kutu); return; }
      Promise.all(taslar.map(suggest)).then(function (L) {
        var gor = {}, sec = [], i = 0, gv = 0;
        while (sec.length < 4 && gv < 60) {
          var l = L[i % L.length], p = l && l.shift();
          if (p && p.url && !gor[p.url]) { gor[p.url] = 1; sec.push(p); }
          i++; gv++; if (L.every(function (x) { return !x || !x.length; })) break;
        }
        if (!sec.length) { if (kutu.parentNode) kutu.parentNode.removeChild(kutu); return; }
        return Promise.all(sec.map(function (p) { return urunJs(p.url); })).then(function (DL) {
          var liste = [];
          DL.filter(Boolean).forEach(function (pj) {
            var vs = (pj.variants || []).filter(function (v) { return v.available; }).map(function (v) { return { i: v.id, t: v.title }; });
            var g = pj.featured_image || (pj.images && pj.images[0]) || '';
            if (g && g.slice(0, 2) === '//') g = 'https:' + g;
            if (g && g.indexOf('?') < 0) g += '?width=500';
            liste.push({ t: pj.title, u: '/products/' + pj.handle, g: g, f: pj.price, k: pj.compare_at_price || 0,
                         o: (pj.options && pj.options[0] && pj.options[0].name) || '', v: vs });
          });
          var anahtar = 'async-' + (kutu.dataset.etiket || '');
          URUN[anahtar] = liste;
          var h2 = urunler(anahtar, 4, kutu.dataset.etiket || '');
          if (!h2) { if (kutu.parentNode) kutu.parentNode.removeChild(kutu); return; }
          var tmp = document.createElement('div'); tmp.innerHTML = h2;
          var yeni = tmp.firstChild; kutu.parentNode.replaceChild(yeni, kutu); urunOlaylari(yeni);
        });
      });
    });
  }

  /* e-posta gövdesi: düz veri, HTML'i panel kurar */
  function epostaGovdesi(adres) {
    var h = D.harita;
    var gunesB = I.BURC[h.gezegenler.gunes.burcNo],
        ayB = I.BURC[h.gezegenler.ay.burcNo],
        yukB = I.BURC[h.yukselenBurcNo];
    var gz = ['merkur','venus','mars','jupiter','saturn'].map(function (k) {
      var g = h.gezegenler[k], b = I.BURC[g.burcNo], m = I.GEZEGEN[k];
      return { sembol:m.sembol, ad:m.ad, burc:b.ad, ev:g.ev, kisa:m.kisa,
               metin: m.ad+' senin '+m.islev+'. '+b.ad+' burcunda olduğu için bu taraf '+b.ton+' işliyor.' };
    });
    var el = h.denge.element;
    var enCok = Object.keys(el).sort(function(a,b){return el[b]-el[a];})[0];
    var kol = gunesB.koleksiyon;
    var urn = (URUN[kol]||[]).slice(0,4).map(function (p) {
      /* Liquid image_url protokolsüz (//) adres verir; e-posta istemcileri çözemez. */
      return { t:p.t, u:p.u, g:(p.g||'').replace(/^\/\//,'https://'), f:paraFmt(p.f,PARA) };
    });
    return {
      test_kod: D.testId, tur:'dogum-haritasi', store: (VERI.store || 'saff'), email: adres, ad: D.ad,
      dogum: D.gun+' '+AYLAR[D.ay-1]+' '+D.yil + (D.saatBilinmiyor?'':' · '+(D.saat<10?'0':'')+D.saat+':'+(D.dakika<10?'0':'')+D.dakika) + ' · ' + D.sehir.ad,
      gunes: { burc:gunesB.ad, element:gunesB.element, ev:h.gezegenler.gunes.ev, metin:gunesB.oz },
      ay:    { burc:ayB.ad, element:ayB.element, ev:h.gezegenler.ay.ev, metin:ayB.duygu },
      yukselen: { burc:yukB.ad, element:yukB.element, metin:yukB.maske },
      gezegenler: gz,
      element_denge: el, element_metin: I.ELEMENT[enCok].baskin,
      taslar: gunesB.taslar, urunler: urn
    };
  }

})();
